// libraries
import type { OfferType } from '@makemydeal/dr-platform-types';
import type { AnyAction } from 'redux';

export type OfferReduxReducerConfig = {
    sourceApplication?: string;
    selectors?: {
        shouldRevertPaymentOnFailure?: { (state: any, action: AnyAction, offerType: OfferType): boolean };
    };
};

export let reducerConfig: OfferReduxReducerConfig;

export const configureReducer = (config: OfferReduxReducerConfig) => {
    reducerConfig = config;
};
